
export const ICON_BUTTON_VARIANTS = {
  OUTLINED: "outlined",
  CLEAR: "clear"
};

export const ICON_BUTTON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge"
};

export const ICON_COLOR_MODES = {
  FILL: "fill",
  STROKE: "stroke"
};
